// extracted by mini-css-extract-plugin
export default {"container":"LRNlz1hiNf2EWOxSfRlf","fader":"SEV4dDcMyk8cCjCuRNfQ"};